<template>
    <div id="count2">
        <transition name="fade">
            <Loading v-if="isLoading" />
        </transition>
        <goTop />
        <step :stepNumber="1"/>
        <div class="content">
            <div class="container">
                <h2 class="title2">保費試算</h2>
                <attention />
                <h3 class="blueTitle">國內旅行綜合險保費快算</h3>
                <p class="goCountry">旅遊國家 :
                    <span class="clarity-unmask">台灣</span>
                </p>
                <p class="goDate">旅遊期間 : <span class="clarity-unmask">{{ pageStorage.startEndDateTime }}</span></p>
                <h2 class="title3">選擇旅平險保障</h2>
                <div class="greenLine"></div>
                <div class="form">
                    <div class="inline">
                        <div class="inputControl">
                            <div class="inputTitle">身故及失能或喪葬費用
                                <a class="tra_info_accu"
                                    href="https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html#tra_01"
                                    target="_blank"><img src="../assets/question.svg" alt="" class="question"></a></div>
                            <select class="inputStyle arrow clarity-unmask" v-model="travelAmount" @change="showHarmMedicalAmountList">
                                <option :value="item" v-for="(item,index) in travelAmountList" :key="index">{{ formatMoney(item) }} 萬</option>
                            </select>
                        </div>
                        <div class="inputControl">
                            <div class="inputTitle">傷害醫療 <a class="harm_info_accu"
                                    href="https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html#tra_02"
                                    target="_blank"><img src="../assets/question.svg" alt="" class="question"></a></div>
                            <select class="inputStyle disabled clarity-unmask" v-model="harmMedicalAmount" @change="calculatePrem" disabled>
                                <option :value="item" v-for="(item,index) in harmMedicalAmountList" :key="index">{{ item }} 萬</option>
                            </select>
                        </div>
                    </div>

                    <div class="oneline">
                            <div class="inputTitle">個人賠償責任(每一事故自負額2,500元) <a class="self_info_accu"
                                    href="https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html#tra_10"
                                    target="_blank"><img src="../assets/question.svg" alt="" class="question"></a>
                            </div>
                            <div class="inputStyle clarity-unmask noTouch">體傷20萬 / 財損10萬 / 最高60萬</div>
                    </div>


                    <div class="attentionTxt pinkText" v-if="pageStorage.insureCountList[0].count>0"><img src="noticemark.svg" class="attention" alt="">滿70歲以上長者僅提供身故及失能保額300萬。</div>
                    <div class="attentionTxt pinkText" v-if="pageStorage.insureCountList[3].count>0 || pageStorage.insureCountList[4].count>0"><img src="noticemark.svg" class="attention" alt="">未滿15歲之被保險人僅提供喪葬費用保險金69萬。</div>

                    <div class="attentionBox">
                        <h2>「定額」與「限額」理賠大不同！</h2>
                        <div :class="{mask:!showPlan}">
                            <ul>
                                <li>
                                    <h3>什麼是定額?</h3>
                                    <p>發生保險事故申請理賠時，不用檢附支出費用單據正本，只要提供相關證明(如：訂票證明、搭乘證明、延誤證明…等文件)，符合保單約定時以約定保險金額進行給付。</p>
                                </li>
                            </ul>
                        </div>
                        <div v-show="showPlan">
                            <ul>
                                <li>
                                    <h3>什麼是限額(或稱「實支實付」)?</h3>
                                    <p>發生保險事故申請理賠時，依照承保項目的給付範圍(住宿費、膳食費、交通費；各條款略有不同)，被保險人提供實際合理支出費用的收據正本進行申請，屬於「實支實付」的範圍。</p>
                                </li>
                            </ul>
                        </div>




                        <div class="showPlan" @click="clickShowPlan" :class="{ 'active': showPlan }"><p><span v-if="!showPlan">顯示</span><span v-if="showPlan">隱藏</span>詳細內容</p></div>
                    </div>
                    <h2 class="title3" v-if="!mainPlan.hidePolicy">選擇旅遊不便險方案</h2>
                    <div class="greenLine" v-if="!mainPlan.hidePolicy"></div>
                    <div class="plan active clarity-unmask" v-if="!mainPlan.hidePolicy">
                        <div class="planTitle" :class="mainPlan.planName + '_add_accu'" @click.self="planSelect($event, mainPlan, true)">
                            <p>{{ mainPlan.plan_title }}
                                <a href="https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html#tra_30" target="_blank">
                                    <img src="../assets/question.svg" alt="" class="question" :class="mainPlan.planName + '_info_accu'">
                                </a>
                            </p>
                            <input type="checkbox" class="choose" :name="mainPlan.planName" :checked="mainPlan.isCheck">
                        </div>
                        <ul class="planCon active">
                            <li v-for="(planCon, planCon_index) in mainPlan.plan_content" :key="planCon_index">
                                <p>{{ planCon.listItem }}</p>
                                <p>{{ planCon.listPrice }}</p>
                            </li>
                        </ul>
                    </div>
                    <h2 class="title3" v-if="!planArea">加購其他險種</h2>
                    <p class="center" v-if="!planArea">（符合承保年齡加購才會加計保費）</p>
                    <div class="greenLine" v-if="!planArea"></div>
                    <div class="plan clarity-unmask" v-for="(item, plan_index) in plan" :key="plan_index"
                         :class="{ 'removePlan': item.hidePolicy }">
                        <div class="planTitle" :class="item.planName + '_add_accu'" @click.self="planSelect($event, item, false)">
                            <p>{{ item.plan_title }}
                                <a :class="item.planName + '_info_accu'" :href="item.moreUrl" target="_blank">
                                    <img src="../assets/question.svg" alt="" class="question">
                                </a>
                            </p>
                            <input type="checkbox" class="choose" :name="item.planName" :checked="item.isCheck">
                        </div>
                        <ul class="planCon">
                            <li v-for="(planCon, planCon_index) in item.plan_content" :key="planCon_index">
                                <p>{{ planCon.listItem }}</p>
                                <p>{{ planCon.listPrice }}</p>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="greenLine"></div>
                <div class="countArea">
                    <div class="notice">
<!--                        <div class="noticeCon" v-if="rosters.length > 1">-->
<!--                            <img src="../assets/attention.svg" alt="">-->
<!--                            <p class="red">提醒您，(多人投保)需要簽回要保書唷!</p>-->
<!--                        </div>-->
                    </div>
                    <count :key="reloadCountKey"  @countComplete="countComplete"/>
                </div>
            </div>
        </div>
        <div class="btnArea">
            <router-link :to="'/count1'" class="btn pink count2_back_accu">返回</router-link>
            <button class="btn center count2_go_accu" @click="checkLogin" :disabled="openButton">立即投保</button>
            <div class="anotherBtn">
                <button class="link count2_adjust_accu" @click="clickAdjustment" :disabled="openButton">需要微調保障嗎？</button>
            </div>
        </div>
    </div>
</template>
<script setup>
import {onMounted, reactive, ref} from "vue";
import $ from "jquery";
import {popUp} from "@/utils/popUp";
import Loading from "@/components/loading.vue";
import gtm from "@/utils/gtmDataLayer";
import goTop from "@/components/gotop.vue";
import step from "@/components/step.vue";
import attention from "@/components/attention.vue";
import apiConfig from "@/utils/apiConfig";
import { postApi } from "@/utils/callApi";
import Swal from "sweetalert2";
import {useRouter} from "vue-router";
import count from "@/components/count.vue";

        const router = useRouter();//轉跳router
        const isLoading = ref(false);
        const pageStorage = ref(null);
        const countDays = ref(0);//總計天數
        let amountList = {};//載入保額清單
        let travelAmountList = ref([])//顯示保額
        const travelAmount = ref(0);//選擇死亡及失能保額
        let harmMedicalAmountList = ref([])//顯示保額
        const planArea = ref(false);//顯示加價購區域
        const harmMedicalAmount = ref(0);//選擇傷害醫療保額
        const openButton = ref(true);
        const carMotorPolicy=ref(false);
        const showPlan = ref(false);

        //全域險種開關
        let mainPlan = reactive({
            isCheck: true,
            planCode: "I00",
            planName: "buyUneasyPolicy",
            plan_title: "國內旅遊不便險",
            hidePolicy: false,
            plan_content: [
                {
                    listItem: "境內班機延誤保險金(定額)",
                    listPrice: "定額 2,000",
                },
                {
                    listItem: "境內旅程取消或縮短保險",
                    listPrice: "限額 1萬",
                },
                {
                    listItem: "境內劫持事故補償費用保險",
                    listPrice: "定額 1萬",
                },
                {
                    listItem: "旅行期間行動電話強盜搶奪補償保險",
                    listPrice: "定額 3,000",
                },
                {
                    listItem: "食物中毒慰問保險金",
                    listPrice: "定額 3,000",
                },
                {
                    listItem: "旅行期間居住所動產損失保險(每一事故自負額5,000元)",
                    listPrice: "限額 10萬",
                },
                {
                    listItem: "旅行期間居家竊盜保險",
                    listPrice: "限額 5萬",
                },
                {
                    listItem: "旅行期間居家火災臨時住宿補償保險",
                    listPrice: "定額 1萬",
                },
                {
                    listItem: "旅行期間居住所第三人責任保險",
                    listPrice: "限額 30萬",
                },
            ]
        });//主險種
        let plan = reactive([
            {
                id: 0,
                plan_title: "國內租借汽車保險(限18歲有駕照者投保)",
                moreUrl: "https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html#tra_23",
                isCheck: false,
                planName: "buyCarPolicy",
                hidePolicy:false,
                plan_content: [
                    {
                        listItem: "車對車碰撞車體損失責任保險",
                        listPrice: "限額 5萬"
                    },
                    {
                        listItem: "第三人責任保險-每一人體傷/每一意外事故",
                        listPrice: "限額 10萬/20萬"
                    },
                    {
                        listItem: "第三人責任保險-第三人財損  ",
                        listPrice: "限額 3萬"
                    }
                ]
            },
            {
                id: 1,
                plan_title: "國內租借機車保險(限18歲有駕照者投保)",
                moreUrl: "https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html#tra_23",
                isCheck: false,
                hidePolicy: false,
                planName: "buyMotorPolicy",
                plan_content: [
                    {
                        listItem: "車對車碰撞車體損失責任保險",
                        listPrice: "限額 5萬"
                    },
                    {
                        listItem: "第三人責任保險-每一人體傷/每一意外事故",
                        listPrice: "限額 10萬/20萬"
                    },
                    {
                        listItem: "第三人責任保險-第三人財損  ",
                        listPrice: "限額 3萬"
                    }
                ]
            },
            {
                id: 2,
                plan_title: "三鐵活動保險(限15歲以上投保)",
                moreUrl: "https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html#ironman",
                isCheck: true,
                hidePolicy: false,
                planName: "buyTriathlon",
                plan_content: [
                    {
                        listItem: "特定事故傷害醫療保險(熱痙攣/中暑)(路跑/自行車/游泳)",
                        listPrice: "共用傷害醫療保額"
                    },
                    {
                        listItem: "急難救助保險",
                        listPrice: ""
                    },
                    {
                        listItem: "搜索救助保險金",
                        listPrice: "限額 30萬"
                    },
                    {
                        listItem: "醫療運送保險金",
                        listPrice: " 限額 5萬"
                    },
                    {
                        listItem: "親人前往處理費用保險金",
                        listPrice: " 限額 5萬"
                    }
                ]
            },
            {
                id: 3,
                plan_title: "交通意外保險(限15歲以上投保)",
                moreUrl: "https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html#tra_39",
                isCheck: true,
                hidePolicy: false,
                planName: "buyTrafficAccident",
                plan_content: [
                    {
                        listItem: "大眾運輸事故保險",
                        listPrice: "100萬"
                    },
                    {
                        listItem: "境內國道事故保險",
                        listPrice: "100萬"
                    }
                ]
            },
            // {
            //     id: 4,
            //     plan_title: "重大燒燙傷保險",
            //     moreUrl: "https://www.tmnewa.com.tw/b2c_v2/insuresinfo/travel-product.html#tra_22",
            //     isCheck: false,
            //     hidePolicy: false,
            //     planName: "buyBurnPolicy",
            //     plan_content: [
            //         {
            //             listItem: "(勾選此項保障，須簽回要保書)",
            //             listPrice: "100萬"
            //         }
            //     ]
            // }
        ]);//加價購險種
        const reloadCountKey = ref(0);
        let rosters = [];//被保人清單
        let adjustData = [];//微調清單
        const policyType = ref("");
        const policyTypeSwitch = ref("");
        let globalHidePlan = {//true: 隱藏方案 false:開啟方案
                buyUneasy: false,
                buyCar: false,
                buyMotor: false,
                buyTriathlon: false,
                buyTraffic: false,
                buyBurn: false,
        }
        //載入 pageStorage
        const loadPageStorage = () =>{
            pageStorage.value = JSON.parse(sessionStorage.getItem("pageStorage"));
            //初始化資料
            if (pageStorage.value != null) {
                travelAmount.value = pageStorage.value.travelAmount ?  pageStorage.value.travelAmount :0;
                harmMedicalAmount.value = pageStorage.value.harmMedicalAmount ?  pageStorage.value.harmMedicalAmount :0;
                mainPlan = pageStorage.value.mainPlan ? pageStorage.value.mainPlan : mainPlan;
                plan = pageStorage.value.plan ? pageStorage.value.plan : plan;
                countDays.value = pageStorage.value.countDays ? pageStorage.value.countDays:0;
                policyType.value = pageStorage.value.policyType ? pageStorage.value.policyType : policyType.value;
                policyTypeSwitch.value = pageStorage.value.getPolicyTypeSwitch ? pageStorage.value.getPolicyTypeSwitch : policyTypeSwitch.value;
                globalHidePlan = pageStorage.value.globalHidePlan ? pageStorage.value.globalHidePlan : globalHidePlan;
                taiwanPolicy();
            }
        }
        //載入意外死亡&傷害醫療保費選項
        const getIndexAmount = () => {
            const data = {
                'policyType': pageStorage.value.policyType,
                'schengenFlag': pageStorage.value.haveSchengenFlag,
                'elderCount': pageStorage.value.insureCountList[0].count,
                'adultCount': pageStorage.value.insureCountList[1].count,
                'youthCount': pageStorage.value.insureCountList[2].count,
                'childCount': pageStorage.value.insureCountList[3].count,
                'babyCount': pageStorage.value.insureCountList[4].count,
                'travelArea':'A'
            }
            postApi(apiConfig.getIndexAmount, null, null, null, data)
                .then((response) => {
                    var getIndexAmountRes = response.data
                    if (getIndexAmountRes.code === 200) {
                        amountList = getIndexAmountRes.data;
                        showTravelAmountList();
                    } else {
                        //跳出錯誤
                        Swal.fire({
                            title: "頁面載入錯誤",
                            showConfirmButton: false,
                            showCloseButton: true,
                            html: '<img src="error.svg"><p>'+ getIndexAmountRes.message + '</p>',
                        });
                    }
                })
                .catch(() => {
                    //跳出錯誤
                    Swal.fire({
                        title: "頁面載入錯誤",
                        showConfirmButton: false,
                        showCloseButton: true,
                        html: '<img src="error.svg"><p>保額清單載入錯誤</p>',
                    })
                        .then(function () {
                            router.push("/");
                        });
                })
        }
// 總保費加上千分位號","
const formatMoney = (value) => {
    if (value === null || value === undefined) return null;
    return parseFloat(value).toLocaleString("zh-TW", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 50,
    });
};
        const clickShowPlan = () =>{
            showPlan.value = !showPlan.value;
        }
        //載入死亡及失能
        const  showTravelAmountList = () =>{
            travelAmountList.value = amountList.travelAmountList;
            if (travelAmount.value === 0) {
                travelAmount.value = Math.max.apply(Math, travelAmountList.value);
                if(travelAmount.value >=1000){
                    travelAmount.value = 1000
                }
            }
            showHarmMedicalAmountList();
        }
        //載入傷害醫療
        const showHarmMedicalAmountList = () => {
            harmMedicalAmountList.value = amountList.harmMedicalAmountList[travelAmount.value];
            var maxHarmMedicalAmount = Math.max.apply(Math, harmMedicalAmountList.value);
            if (harmMedicalAmount.value > maxHarmMedicalAmount) {
                harmMedicalAmount.value  = maxHarmMedicalAmount
            }
            if(harmMedicalAmount.value  === 0){
                harmMedicalAmount.value  = maxHarmMedicalAmount;
                if(harmMedicalAmount.value  >=50){
                    harmMedicalAmount.value  = 50
                }
            }
            calculatePrem();
        }

        const calculatePrem=()=> {

            openButton.value = true;
            createRosters();

            pageStorage.value = JSON.parse(sessionStorage.getItem("pageStorage"));//抓最新的再重新塞

            pageStorage.value.travelAmount = travelAmount.value;
            pageStorage.value.harmMedicalAmount = harmMedicalAmount.value;
            pageStorage.value.mainPlan = mainPlan;
            pageStorage.value.plan = plan;
            pageStorage.value.rosters = rosters;
            pageStorage.value.amountList = amountList;
            pageStorage.value.adjustData = adjustData;

            sessionStorage.setItem("pageStorage", JSON.stringify(pageStorage.value));

            reloadCountKey.value += 1;//觸發count components 重新載入
        }

        // 國內旅平各項規則
        const taiwanPolicy= () =>{
            // 全域開關
            mainPlan.hidePolicy = globalHidePlan.buyUneasy;
            if(globalHidePlan.buyUneasy){
                mainPlan.isCheck = false;
            }

            var CarObject = plan.find(p => p.planName === "buyCarPolicy");
            var MotorObject = plan.find(p => p.planName === "buyMotorPolicy");
            var TriathlonObject = plan.find(p => p.planName === "buyTriathlon");
            var TrafficObject = plan.find(p => p.planName === "buyTrafficAccident");
            // var BurnObject = plan.find(p => p.planName === "buyBurnPolicy");

            CarObject.hidePolicy = globalHidePlan.buyCar;
            if(globalHidePlan.buyCar){
                CarObject.isCheck = false;
            }
            MotorObject.hidePolicy = globalHidePlan.buyMotor;
            if(globalHidePlan.buyMotor){
                MotorObject.isCheck = false;
            }
            TriathlonObject.hidePolicy = globalHidePlan.buyTriathlon;
            if(globalHidePlan.buyTriathlon){
                TriathlonObject.isCheck = false;
            }
            TrafficObject.hidePolicy = globalHidePlan.buyTraffic;
            if(globalHidePlan.buyTraffic){
                TrafficObject.isCheck = false;
            }
            // BurnObject.hidePolicy = globalHidePlan.buyBurn;
            // if(globalHidePlan.buyBurn){
            //     BurnObject.isCheck = false;
            // }

            //重大燒燙傷
            // if (policyType.value === "INSURE"){ //網要才能投保(網投INSURE狀況時隱藏)
            //     BurnObject.hidePolicy = true;
            // }

            //汽機車投保、三鐵、交通意外
            var adultCount = pageStorage.value.insureCountList[0].count;
            var elderCount = pageStorage.value.insureCountList[1].count;
            var youthCount = pageStorage.value.insureCountList[2].count;
            var childCount = pageStorage.value.insureCountList[3].count;
            var babyCount = pageStorage.value.insureCountList[4].count;
            if(childCount+babyCount >=1 && elderCount === 0 && adultCount ===0 && youthCount ===0){//僅有小孩
                CarObject.hidePolicy = true;
                MotorObject.hidePolicy = true;
                TriathlonObject.hidePolicy = true;
                TrafficObject.hidePolicy = true;
            }
            if(youthCount >=1 && elderCount === 0 && adultCount ===0 ){//青少年 兒童 幼童
                CarObject.hidePolicy = true;
                MotorObject.hidePolicy = true;
            }

            //關閉網要
            // if(policyTypeSwitch.value === 'I'){
            //     BurnObject.hidePolicy = true
            // }

            //沒有加價購 不顯示 title 綠線
            let showPlanCount = 0;
            plan.forEach(planObject => {
                if(planObject.hidePolicy === false){
                    showPlanCount += 1;
                }
            });
            if(showPlanCount === 0){
                planArea.value = true;
            }

        }
        //計算完畢
        const countComplete = ()=>{
            openButton.value = false;
        }
        //建立rosters
        const createRosters = () =>{
            rosters = [];//重新產出
            var rosterNum = 0;

            pageStorage.value.insureCountList.forEach((insureCount) => {

                var rosterTravelAmount = travelAmount.value;
                var rosterHarmMedicalAmount = harmMedicalAmount.value;

                switch (insureCount.rosterType) {
                    //價格寫死的醫療傷害老人50000、小孩60000
                    case 2:
                        rosterTravelAmount = 300;
                        rosterHarmMedicalAmount = 5;
                        break;
                    case 3:
                    case 4:
                        rosterTravelAmount = 69;
                        rosterHarmMedicalAmount = 5;

                }

                if (insureCount.count > 0) {
                    //rosterType 1:大人(18~70) 2:長者(70~80) 3:兒童(7~15) 4:幼童(0~7) 5:青少年(15~18)
                    for (var i = 1; i <= insureCount.count; i++) {
                        rosterNum++;
                        var roster = {
                            'rosterNum': rosterNum,
                            'rosterType': insureCount.rosterType,
                            'travelAmount': rosterTravelAmount * 10000,
                            'harmMedicalAmount': rosterHarmMedicalAmount * 10000,
                            'buyUneasyPolicy': mainPlan.isCheck,//旅遊不便險
                            'buyCarPolicy': insureCount.rosterType >= 3 ? false : plan[0].isCheck,//汽車
                            'buyMotorPolicy': insureCount.rosterType >= 3 ? false : plan[1].isCheck,//機車
                            'buyTriathlon': insureCount.rosterType === 3 || insureCount.rosterType === 4 ? false : plan[2].isCheck,//三鐵
                            'buyTrafficAccident': insureCount.rosterType === 3 || insureCount.rosterType === 4 ? false : plan[3].isCheck,//交通意外
                            'buyBurnPolicy': false,//重大燒燙
                            // 'buyBurnPolicy': plan[4].isCheck,//重大燒燙
                        };
                        rosters.push(roster);
                    }
                }
            });

            createAdjustData();
        }

        const loadPlanSelect = () => {
            if(!mainPlan.hidePolicy){
                const mainPlanLoad = document.getElementsByName(mainPlan.planName);
                if (mainPlan.isCheck) {
                    mainPlanLoad[0].parentElement.parentElement.classList.add('active');
                    mainPlanLoad[0].parentElement.nextElementSibling.classList.add('active');
                } else {
                    mainPlanLoad[0].parentElement.parentElement.classList.remove('active');
                    mainPlanLoad[0].parentElement.nextElementSibling.classList.remove('active');
                }
            }

            plan.forEach(planObject => {
                if(!planObject.hidePolicy){
                    const planLoad = document.getElementsByName(planObject.planName);
                    if (planObject.isCheck) {
                        planLoad[0].parentElement.parentElement.classList.add('active');
                        planLoad[0].parentElement.nextElementSibling.classList.add('active');
                    } else {
                        planLoad[0].parentElement.parentElement.classList.remove('active');
                        planLoad[0].parentElement.nextElementSibling.classList.remove('active');
                    }
                }
            });

        }

        const planSelect = (event, item) =>{
            item.isCheck = !item.isCheck;
            var vm = event.target;
            var planCon = $(vm).next('.planCon');
            if (item.isCheck) {
                $(vm).parent('.plan').addClass('active');
                planCon.slideDown();
            } else {
                $(vm).parent('.plan').removeClass('active');
                planCon.slideUp();
            }

            calculatePrem();
        }
        const checkLogin = () =>{
            calculatePrem();
            sendDataLayer('add_to_cart');
            const jwtInfo = localStorage.getItem("jwtInfo");

            Swal.fire({
                title: "重要提醒",
                confirmButtonText: "已經確認",
                cancelButtonText:"重新確認",
                reverseButtons:true,
                showCancelButton:true,
                showCloseButton:false,
                allowOutsideClick:false,
                customClass: {container: "alert80vh"},
                html: '<p><img src="noticemark.svg" alt="notice" class="noticemark"><p>'+
                    '<ul><li>若您投保的保險方案包含「限額」保障，其理賠方式為「實支實付」，<span class="red">申請理賠須提供「正本收據」</span>。</li>' +
                    '<li>發生保險事故產生實際合理支出時，<span class="red">請妥善保存正本收據</span>，以確保您的理賠權益。<span class="red">收據僅能核銷單一理賠項目</span>，除非單項保額超過，否則恕無法同時適用於多個險種。</li></ul>' +
                    '<p class="pSpace">請提前投保，並於投保前確認所選方案是否符合您的需求。感謝您的理解與配合！</p>'
            }).then((result) => {
                if (result.isConfirmed) {
                    isLoading.value = true;
                    sessionStorage.setItem("bannerLogin", false);
                    var CarObject = plan.find(plan => plan.planName === "buyCarPolicy");
                    var MotorObject = plan.find(plan => plan.planName === "buyMotorPolicy");
                    if(CarObject.isCheck === true){
                        router.push("/adjustment");
                        carMotorPolicy.value = true;
                    }
                    else if(MotorObject.isCheck === true){
                        router.push("/adjustment");
                        carMotorPolicy.value = true;
                    }
                    else{
                        carMotorPolicy.value = false;
                        if (jwtInfo != null) {
                            router.push("/detail");
                        } else {
                            router.push("/login");
                            isLoading.value = false;
                        }
                    }

                } else if (result.isDenied) {
                    Swal.close()
                }

            });

        }
        const sendDataLayer = (event) => {
            gtm.policyEvent(event, pageStorage.value.calculatePremRes.totalPremium
                , null, null, null, null
                , 'optional_taiwan', '自行試算');
        }
        const clickAdjustment = () => {
            calculatePrem();
            sendDataLayer('remove_from_cart');
            router.push('/adjustment');
        }
        //建立adjust
        const createAdjustData = () => {
            adjustData = [];//重新產出

            let adultCount = 0;
            let elderCount = 0;
            let youthCount = 0;
            let childCount = 0;
            let babyCount = 0;

            rosters.forEach((roster) => {
                let adjust = {};
                switch (roster.rosterType) {
                    case 1:
                        adultCount++;
                        adjust.user = "大人" + adultCount;
                        adjust.icon = require('@/assets/adult.svg');
                        break;
                    case 2:
                        elderCount++
                        adjust.user = "長者" + elderCount;
                        adjust.icon = require('@/assets/elder.svg');
                        break;
                    case 3:
                        childCount++
                        adjust.user = "兒童" + childCount;
                        adjust.icon = require('@/assets/child.svg');
                        break;
                    case 4:
                        babyCount++
                        adjust.user = "幼童" + babyCount;
                        adjust.icon = require('@/assets/baby.svg');
                        break;
                    case 5:
                        youthCount++
                        adjust.user = "青少年" + youthCount;
                        adjust.icon = require('@/assets/youth.svg');
                        break;
                }
                adjust.type = roster.rosterType;
                adjust.is_check = false;
                adjust.user_id = roster.rosterNum;

                adjustData.push(adjust);
            });
        }

        //載入 pageStorage 生成頁面需使用 放在setup區域
        loadPageStorage();
        //載入意外死亡&傷害醫療保費選項
        getIndexAmount();
        //國外旅平各項規則
        taiwanPolicy();

        onMounted(()=>{
            gtm.pageViewEvent();//新增pageViewEvent
            popUp();//公告系統
            loadPlanSelect();
            $("#step li:nth-of-type(1)").find(".number").addClass('active'); //設定哪個step亮黃圈
            //一定要刪的session
            sessionStorage.removeItem('fromPage');
            sessionStorage.removeItem("registerStorage");
            //無要保序號就要刪的session
            const applicationNo = sessionStorage.getItem("applicationNo");
            if(applicationNo != null){
                let removeStorage = ['detailStorage','applicationNo','insTraOrderId','confirmPolicyType','otp'];
                removeStorage.forEach(k =>
                    sessionStorage.removeItem(k)
                )
            }
        })
</script>
<style lang="scss">
#count2 {
    .oneline{margin-bottom:30px;}
    color: $textColor;
  .goDate,
  .goCountry {
    margin: 5px 0;
  }
    .plan {
        margin: 30px auto;
        cursor: pointer;
        width: 100%;
        overflow: hidden;
        background: $gray;
        border-radius: 20px;

        &.removePlan{
          display:none;
        }
        &.active {
            background: #fff;
            border-radius:0;
            .planTitle {
                background: $blue-700;
                box-sizing: border-box;
                padding: 10px;
                border-top-left-radius: 20px;
                border-top-right-radius: 20px;
                p{color:#fff;border-left: 3px solid #fff;}
                &::after {
                    content: "已加購";
                    padding: 5px 30px 5px 10px;
                    box-sizing: border-box;
                    text-align: left;
                    background-image: url("@/assets/TitleIcon.svg");
                    background-position: left calc(100% - 10px) center;
                    display: inline-block;
                    vertical-align: middle;
                    background-repeat: no-repeat;
                }
            }
        }

        ul {
            box-sizing: border-box;
            padding: 0 10px;

            li {
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                -webkit-box-pack: justify;
                -ms-flex-pack: justify;
                justify-content: space-between;
                line-height: 40px;
                font-weight: 500;
                padding: 3px 0;

                .inputStyle {
                    width: 40%;
                }
            }
        }
    }

    .planTitle {
        background: $gray-400;
        box-sizing: border-box;
        padding: 10px;
        position: relative;
        display: flex;
        vertical-align: middle;
        align-items: center;
        min-height:50px;
        a{width:18px;
            height: 18px;
            margin-right: 10px;
            display: inline-block;
            position: relative;
            top: 3px;
            margin-left: 6px;
            img{width: 100%;}
        }
        p {
            padding-left: 10px;
            color: $textColor;
            border-left: 3px solid $textColor;
            display: inline-block;
            margin-right: 5px;
            @media screen and (max-width: $small) {width: 68%;}
        }

        &::after {
            content: "加購";
            position: absolute;
            box-sizing: border-box;
            padding: 5px 30px 5px 10px;
            right:10px;
            //min-width:108px;
            color:#fff;
            border-radius: 100px;
            background-color:$pink;
            background-image: url(../assets/addTitleIcon.svg);
            background-position: left calc(100% - 10px) center;
            background-repeat: no-repeat;
            display: inline-block; /* 確保圖片與文字在同一行 */
            vertical-align: middle; /* 對齊文字 */

        }
        .question{position:static}
    }

    .planCon {
        display: none;
        border: 2px solid $blue-700;
        padding-top:10px;
      border-bottom-left-radius: 20px;
      border-bottom-right-radius: 20px;
        &.active {
            display: block;
          padding-top:10px;
        }

        @media screen and (max-width: $small) {
            li {
                font-size: 15px;
                margin: 10px 0;
                vertical-align: middle;

                p {
                    &:first-child {
                        width: 59%;
                        text-align: left;
                        line-height: 20px;
                    }

                    &:last-child {
                        width: 40%;
                        line-height: 20px;
                        text-align: right;
                    }
                }
            }
        }
    }

    .choose {
        opacity: 0
    }

    .notice {
        width: 45%;
        display: flex;
        vertical-align: top;

        @media screen and (max-width: $small) {
            width: 100%;
            font-size: 15px;
        }

        p {
            margin-left: 35px;

            @media screen and (max-width: $small) {
                margin-left: 25px;
            }
        }

        img {
            width: 30px;
            position: absolute;

            @media screen and (max-width: $small) {
                width: 20px;
            }
        }

        p,
        img {
            display: inline-block
        }
    }

}
</style>
